export default __webpack_public_path__ + "static/media/slack.d0b7dd95.svg";